<style scoped lang="scss">
.wrap-primer {
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .title {
    h3 {
      font-size: 24px;
      font-weight: bold;
    }
  }

  .el-steps {
    width: 350px;
  }

  .remark {
    background: #F9F9F9;
    padding: 15px 20px;
    margin-top: 20px;
  }

  .product {
    display: flex;
    align-items: center;
    text-align: left;

    .img-box {
      width: 106px;
      height: 106px;
      display: flex;
      align-items: center;
      justify-content: center;
      //overflow: hidden;
    }

    img {
      width: 106px;
      margin-right: 20px;
    }

    .title {
      font-size: 16px;
    }

    p {
      color: #999;
    }
  }

  .total {
    background: #F0F0F0;
    text-align: right;

    span {
      margin-right: 30px;
      display: inline-flex;
      align-items: center;
    }

    .price {
      font-weight: bold;
      font-size: 20px;
      color: #014492;

      small {
        font-size: 12px;
        font-weight: normal;
      }
    }

    .el-button {
      font-size: 20px;
      padding: 14px 20px;
    }
  }
}

.order ul {
  display: flex;
  flex-wrap: wrap;
  height: 180px;
  margin-top: 20px;
}

.order ul li {
  position: relative;
  width: 180px;
  margin-right: 20px;
  transition: box-shadow 0.3s;
}

.order ul li:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}


.order ul li .name {
  position: relative;
  padding-top: 35px;
  padding-bottom: 10px;
  color: #ffffff;
  text-align: center;
  overflow: hidden;
  background-color: #3bc9db;
  background: -webkit-linear-gradient(55deg, #3bc9db, #66d9e8);
  background: -moz-linear-gradient(55deg, #3bc9db, #66d9e8);
  background: linear-gradient(55deg, #3bc9db, #66d9e8);
}

.order ul li.disabled .name {
  background-color: #9c9c9c;
}

.order ul li .name:after {
  position: absolute;
  top: -5px;
  left: 50%;
  content: "";
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffffff;
  transform: translate(-50%, -50%);
}

.order ul li .name h5 {
  margin-bottom: 30px;
  padding: 0 30px;
  font-size: 20px;
}

.order ul li .name p {
  color: #008085;
}

.order ul li.disabled .name p {
  color: #333333;
}

.order ul li .store {
  position: relative;
  padding: 20px 15px;
  color: #666666;
  text-align: center;
  background-color: #f8f8f8;
}

.order ul li .store:after {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  content: "";
  height: 3px;
  background: url("../../assets/img/coupon.png") repeat-x;
}

.order ul li .store .text-left {
  display: block;
  text-align: left;
  color: #666666 !important;
  margin-bottom: 10px;
}

.order ul li .store p {
  display: block;
  margin-bottom: 10px;
}

.order ul li .store span {
  color: #333333;
}

.order ul li .store .btn {
  display: inline-block;
  width: 120px;
  border: 1px solid #4fc8cc;
  margin-bottom: 0;
  padding: 7px 0;
  color: #4fc8cc;
  border-radius: 20px;
  outline: none;
  background-color: transparent;
  transition: color 0.3s, border-color 0.3s;
}

.order ul li .store .btn:hover {
  color: #014492;
  border-color: #014492;
}

.order .top {
  overflow: auto;

  .you {
    font-size: 14px;
    margin-top: 10px;

    a {
      color: #666666;
    }
  }
}

.order h4 {
  padding-top: 20px;
  font-size: 20px;
  padding-bottom: 20px;
}

.order ul .color {
  background: #3bc9db url("../../assets/img/coupon1.png") 150px 8px no-repeat !important;
}

.summary {
  overflow: auto;
  padding: 0 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  border-radius: 0;
  border: none;
}

.pull-right {
  float: right !important;
}

.summary .dl-horizontal dt {
  line-height: 20px;
  float: left;
  margin-top: 5px;
  width: 160px;
  clear: left;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: normal;
  color: #999999;
}

.summary .dl-horizontal dd {
  line-height: 20px;
  color: #666666;
  margin-top: 5px;
  float: left;
}
</style>
<template>
  <div class="wrap wrap-primer">
    <section class="container">
      <div class="top">
        <div class="title">
          <h3>分子产品商城购物车</h3>
          <p>（温馨提示：请您确认订单发货数量）</p>
        </div>
        <el-steps :active="1" finish-status="success" align-center>
          <el-step title="勾选商品并提交"></el-step>
          <el-step title="确认并提交订单"></el-step>
        </el-steps>
      </div>
      <qk-edit-address/>
      <el-input
        type="textarea"
        :rows="5"
        placeholder="请输入订单备注信息"
        class="mt20"
        v-model="remark"></el-input>
      <div class="order" v-if="this.list2 < this.list3">
        <h4>优惠券</h4>
        <ul style="margin-bottom: 20px;">
          <li v-for="(item,index) in list1" :key="index" @click="changeSpan(item,index)" id="btn_one" @mouseover="mouseOver(item)">
            <div class="name" :class="{'color':spanIndex.indexOf(index)>-1}">
              <h5>{{ item.name }}</h5>
<!--              <p>无使用期限</p>-->
              <p v-if="item.beginDate">{{ item.beginDate | rTime1 }} 至 {{item.endDate | rTime1}}</p>
              <p v-else>无使用期限</p>
            </div>
            <div class="store">
              <a class="text-left" target="_blank">
                <span>限店铺:</span>
                {{ item.storeId | stateFormat(item.storeId)}}
              </a>
            </div>
          </li>
        </ul>
      </div>
      <el-table
        class="mt20"
        v-if="type === 'chart'"
        :data="tableData">
        <el-table-column
          header-align="left"
          label="产品信息">
          <template slot-scope="scope">
            <div class="product">
              <div class="img-box">
                <img :src="scope.row.skuThumbnail">
<!--                <img :src="scope.row.img">-->
              </div>
              <div class="info">
                <div class="title">{{ scope.row.skuName }}</div>
                <p>货号：{{ scope.row.skuCode }}</p>
                <p>规格：{{scope.row.specificationValues[0].value}},{{scope.row.specificationValues[1].value}}</p>
<!--                <div class="title">{{ scope.row.text }}</div>-->
<!--                <p>规格：{{ scope.row.gui }}</p>-->
<!--                <p>尺寸：{{ scope.row.chi }}</p>-->
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          align="center"
          label="单价（元）">
          <template slot-scope="scope">{{ scope.row.price | amount }}</template>
        </el-table-column>
        <el-table-column
        prop="quantity"
        label="数量">
        </el-table-column>
        <el-table-column
        label="小计（元）">
        <template slot-scope="scope">
        {{ scope.row.price * scope.row.quantity | amount }}
        </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="num"-->
<!--          width="100px"-->
<!--          align="center"-->
<!--          label="数量">-->
<!--        </el-table-column>-->
<!--        <el-table-column-->
<!--          width="100px"-->
<!--          align="center"-->
<!--          label="小计（元）">-->
<!--          <template slot-scope="scope">-->
<!--            {{ scope.row.price * scope.row.num | amount }}-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          width="200px"
          align="center"
        label="发货数量">
        <template slot-scope="scope" >
          <div v-if="scope.row.type === 'SELF'">
            <el-input-number v-model="scope.row.deliveryNum" :min="1" :max="scope.row.quantity"></el-input-number>
          </div>
        <div v-else-if="scope.row.type === 'GENERAL'">
          {{ scope.row.quantity }}
        </div>
        </template>
        </el-table-column>
      </el-table>
      <el-table
        class="mt20"
        v-else
        :data="tableData">
        <el-table-column
          header-align="left"
          label="产品信息"
        >
          <template slot-scope="scope">
            <div class="product">
              <img :src="scope.row.mainImgUrl">
              <div class="info">
                <div class="title">{{ scope.row.name }}</div>
                <p>货号：{{ scope.row.skuDetails.code }}</p>
                <p>规格：{{ scope.row.skuDetails.spec }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          align="center"
          label="单价（元）">
          <template slot-scope="scope">{{ scope.row.skuDetails.price | amount }}</template>
        </el-table-column>
        <el-table-column
          prop="skuNum"
          width="100px"
          align="center"
          label="数量">
        </el-table-column>
        <el-table-column
          width="100px"
          align="center"
          label="小计（元）">
          <template slot-scope="scope">
            {{ scope.row.skuDetails.price * scope.row.skuNum | amount }}
          </template>
        </el-table-column>
        <!--<el-table-column-->
        <!--label="发货数量">-->
        <!--<template slot-scope="scope">-->
        <!--<el-input-number v-model="scope.row.sendNum" :min="0" :max="scope.row.skuNum"></el-input-number>-->
        <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
      <div class="summary">
        <div class="panel-body">
          <dl class="dl-horizontal pull-right">
            <dt>赠送积分:</dt>
            <dd>{{ totalPrice1 | amount }}</dd>
            <dt>优惠券折扣:</dt>
            <dd>
              <span>￥{{ Discount }}元</span>
            </dd>
            <dt>应付金额:</dt>
            <dd>
              <span>￥{{ totalPrice | amount }}元</span>
            </dd>
            <dt>运费:</dt>
            <dd>
              <span>￥{{ Shipping }}元</span>
            </dd>
          </dl>
        </div>
      </div>
      <div class="total mt30">
        <span>已选商品：{{ totalNums }}</span>
        <span>实付金额：<span class="price"><small>￥</small>{{ totalPrice1 | amount }}</span></span>
        <el-button type="primary" @click="onsubmit">确认商品信息并提交</el-button>
      </div>
    </section>
  </div>
</template>
<script>
import cities from '@/utils/citys.json'
import {carts, createProductOrders1} from '@/services/api.index'
export default {
  inject: ['reload'],
  data() {
    return {
      checkedAll: false,
      tableData: [],
      totalPrice: 0,
      totalPrice1: 0,
      priceYou: 0,
      Shipping: 0,
      Discount: 0,
      a: 0,
      totalNums: 0,
      dialogAddressVisible: false,
      cities: cities,
      editAddress: {
        address: [],
        detail: ''
      },
      curAddress: '',
      addressLabel: [],
      spanIndex: [],
      list: [],
      list2: 0,
      list3: 0,
      list1: [],
      userInfo: {},
      remark: '',
      type: this.$route.query.type
    }
  },
  filters: {
    stateFormat(stateId) {
      if(stateId === 1) return '实验耗材'
      if(stateId === 2) return '生化试剂'
      if(stateId === 3) return '科研仪器'
      if(stateId === 4) return '分子生物学'
      if(stateId === 5) return '细胞生物学'
      if(stateId === 6) return '蛋白与免疫'
      return
    }
  },
  created() {
    if (this.type === 'chart') {
      // this.getCarts()
      this.getCarts1()
    } else {
      let goodsInfo = this.tableData.concat(this.baseMethods.getLocalObj('goodsInfo'))
      goodsInfo[0].sendNum = 0
      this.tableData = goodsInfo
      this.totalNums = goodsInfo[0].skuNum
      this.totalPrice = goodsInfo[0].skuNum * goodsInfo[0].skuDetails.price
    }
  },
  methods: {
    changeSpan(item, index) {
      let arrIndex = this.spanIndex.indexOf(index);
      if (arrIndex > -1) {
        this.Discount = 0
        this.totalPrice1 = this.totalPrice
        this.spanIndex.splice(arrIndex, 1);
      } else {
        this.totalPrice1 = 0
        let cc = item.minimumPrice
        let aa = this.totalPrice / 100
        let obj = document.getElementById("btn_one")
        if (cc > aa) {
          this.$message.error('该订单金额小于优惠券满减金额，不可使用')
          this.Discount = 0
          this.totalPrice1 += this.totalPrice
          obj.style.cssText = "cursor: not-allowed;"
          return
        } else {
          this.Discount = item.price
          let arr1 = item.priceExpression.toFixed(2)
          let arr = item.priceExpression.substring(6)
          if(arr1.match(/[\-]/g)){
            this.totalPrice1 += this.totalPrice - arr
            this.totalPrice1 = this.totalPrice1 * 100
          }
          if(arr1.match(/[\*]/g)){
            this.totalPrice1 += this.totalPrice * arr * 100
          }
        }
        this.spanIndex.push(index);
      }
    },
    mouseOver(item) {
      let cc = item.minimumPrice.toFixed(2)
      let aa = this.totalPrice / 100
      let obj = document.getElementById("btn_one")
      if (cc > aa) {
        obj.style.cssText = "cursor: not-allowed;"
      }
    },
    // getCarts() {
    //   carts().then(res => {
    //     this.totalPrice = 0
    //     this.totalNums = 0
    //     res.data.map(item => {
    //       this.totalPrice += item.sku.price * item.quantity
    //       this.totalNums += item.quantity
    //     })
    //     res.data.map(item => {
    //       item.sendNum = 0
    //     })
    //     this.tableData = res.data
    //   })
    // },
    getCarts1() {
      // let arr = []
      // let arr1 = []
      // let arr3 = []
      let arr4 = []
      this.totalPrice1 = 0
      this.totalNums = 0
      // arr = this.baseMethods.getLocalObj('chart')
      arr4 = this.baseMethods.getLocalObj('chart_one')
      // if (arr) {
      //   arr3 = arr.map(item => item.shop_name)
      //   if (arr3.length) {
      //     arr1 = arr.map(item => item.products)
      //     for (let v of Object.values(arr1)) {
      //       this.tableData = this.tableData.concat(v)
      //     }
      //     this.tableData.map(item => {
      //       this.totalPrice += item.price * item.num
      //       this.totalPrice1 += item.price * item.num
      //       this.totalNums += item.num
      //     })
      //   }
      // }
      if (arr4) {
        this.tableData = arr4
        this.tableData.map(item => {
          this.totalPrice += item.price * item.quantity
          this.totalPrice1 += item.price * item.quantity
          this.totalNums += item.quantity
        })
        this.list = this.list1.map(item => item.minimumPrice.toFixed(2))
        this.list2 = parseFloat(this.list)
        this.list3 = this.totalPrice1 / 100
      } else {
        this.tableData = this.baseMethods.getLocalObj('charts')

        this.tableData.map(item => {
          this.list1 = item.discount
          this.totalPrice += item.price * item.quantity
          this.totalPrice1 += item.price * item.quantity
          this.totalNums += item.quantity
        })
      }
    },
    // 确认订单tableData
    onsubmit() {
      let items = []
      let pro = 0
      let b = 0
      this.tableData.map(item => {
        debugger
        if (this.type === 'chart') { // 购物车下单
          pro += item.price * item.quantity / 100
          b = parseFloat(pro)
          items = items.concat({
            skuId: item.skuId,
            storeId: item.storeId,
            quantity: item.quantity,
            storeName: item.storeName,
            deliveryNum:item.deliveryNum
          })
        } else { // 直接购买
          items = items.concat({
            cartItemId: null,
            skuId: item.curSku,
            quantity: item.skuNum,
            sendQuantity: item.sendNum
          })
        }
      })
      const memberInfo = this.baseMethods.getLocalObj('memberInfo')
      if (this.Discount === 0) {
        let submitData = {
          items: items,
          customerId: memberInfo.id,
          address: this.baseMethods.getAddress(),
          remark: this.remark,
          integral: this.totalPrice1
        }
        createProductOrders1(submitData).then(() => {
          if (this.type === 'chart') {
            this.reload()
          }
          this.$message.success('提交成功')
          this.$router.push('/tec/success_submit?type=molecular')
        })
      } else if (this.Discount !== 0) {
        let submitData = {
          items: items,
          customerId: memberInfo.id,
          address: this.baseMethods.getAddress(),
          remark: this.remark,
          coupon: this.list1,
          integral: this.totalPrice1
        }
        createProductOrders1(submitData).then(() => {
          if (this.type === 'chart') {
            this.reload()
          }
          this.$message.success('提交成功')
          this.$router.push('/tec/success_submit?type=molecular')
        })
      } else if (b < 48) {
        if (this.Shipping === 0) {
          this.Shipping = this.Shipping + 10
          return
        }
        this.$message.warning('订单金额低于48元，需另加10元运费')
        let submitData = {
          items: items,
          freight: this.Shipping + 10,
          customerId: memberInfo.id,
          address: this.baseMethods.getAddress(),
          remark: this.remark,
          integral: this.totalPrice1
        }
        createProductOrders1(submitData).then(() => {
          if (this.type === 'chart') {
            this.reload()
          }
          this.$message.success('提交成功')
          this.$router.push('/tec/success_submit?type=molecular')
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/chart_confirm.vue